import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useEffect, useState } from 'react'
import useHistoryApi from '../../api/useHistoryApi';
import CommonLoader from '../loaders/CommonLoader';
import SmartPagination from '../main/Pagination';
import dayjs from 'dayjs';

const RevenueHistorySection = () => {
    const { loading, getRevenueHistory } = useHistoryApi();
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [total_pages, setTotalPages] = useState(1);
    const [selectedStatus, setSelectedStatus] = useState('');
    const [start_date, setStartDate] = useState("");
    const [end_date, setEndDate] = useState("");

    const fetchHistory = async (page = 1, selectedStatus, start_date = '', end_date = "") => {
        const res = await getRevenueHistory(page, selectedStatus, start_date, end_date);
        setData(res.data.payload.allRevenueHistory);
        setTotalPages(res.data.payload.total_pages);
    };

    const handleStatusChange = (e) => {
        const value = e.target.value;
        setSelectedStatus(value);
        fetchHistory(1, value, start_date, end_date)
    };

    useEffect(() => {
        fetchHistory(page, selectedStatus, start_date, end_date);
    }, [page]);

    useEffect(() => {
        if (start_date && end_date) {
            fetchHistory(1, selectedStatus, start_date, end_date);
        }
    }, [start_date, end_date])

    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    const handleClear = () => {
        setSelectedStatus("");
        setStartDate("");
        setEndDate("");
        fetchHistory(1, '', '', '')
    };

    return (
        <div className="">
            <div className="card">
                <div className="card-body">
                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 p-3 rounded shadow-sm">
                        <h6 className="fw-bold text-lg mb-0 me-3">Revenue History</h6>

                        <div className="d-flex flex-wrap align-items-center gap-2">
                            <div>
                                <label htmlFor="statusFilter" className="visually-hidden">Filter by Status</label>
                                <select
                                    id="statusFilter"
                                    className="form-select form-select-sm"
                                    value={selectedStatus}
                                    onChange={handleStatusChange}
                                    style={{ minWidth: '120px' }}
                                >
                                    <option value="">All</option>
                                    <option value="credit">Credit</option>
                                    <option value="debit">Debit</option>
                                </select>
                            </div>

                            <div className="d-flex align-items-center gap-2">
                                <div>
                                    <label htmlFor="start_date" className="visually-hidden">Start Date</label>
                                    <input
                                        id="start_date"
                                        type="date"
                                        className="form-control form-control-sm"
                                        value={start_date}
                                        onChange={(e) => setStartDate(e.target.value)}
                                        style={{ minWidth: '140px' }}
                                    />
                                </div>
                                <span className="text-muted">to</span>
                                <div>
                                    <label htmlFor="end_date" className="visually-hidden">End Date</label>
                                    <input
                                        id="end_date"
                                        type="date"
                                        className="form-control form-control-sm"
                                        value={end_date}
                                        onChange={(e) => setEndDate(e.target.value)}
                                        style={{ minWidth: '140px' }}
                                    />
                                </div>
                            </div>

                            <button
                                className="btn btn-sm btn-outline-primary"
                                onClick={handleClear}
                            >
                                Clear Filters
                            </button>
                        </div>
                    </div>
                    <div className="mt-3">
                        <div className="">
                            {loading ? (
                                <CommonLoader />
                            ) : (
                                <>
                                    <div className="table-responsive scroll-sm">
                                        <table className="table bordered-table sm-table mb-0">
                                            <thead>
                                                <tr>
                                                    <th className="text-start">User</th>
                                                    <th className="text-center">Source</th>
                                                    <th className="text-center">Transaction Type</th>
                                                    <th className="text-center">Title</th>
                                                    <th className="text-center">Description</th>
                                                    <th className="text-center">Amount</th>
                                                    <th className="text-center">Created At</th>
                                                    <th className="text-center">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data.length > 0 ? (
                                                    data.map((data) => (
                                                        <tr key={data._id}>
                                                            <td>
                                                                <div className="d-flex align-items-center">
                                                                    <img
                                                                        src={data?.user_id?.profile_photo}
                                                                        alt=""
                                                                        className="w-40-px h-40-px rounded-circle flex-shrink-0 me-12 overflow-hidden"
                                                                    />
                                                                    <div className="flex-grow-1 d-flex flex-column align-items-start">
                                                                        <h6 className="text-md mb-0">{data?.user_id?.user_name}</h6>
                                                                        <span className="text-sm text-secondary-light fw-medium">
                                                                            {data?.user_id?.phone_number}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td className="text-center">{data?.source || '-'}</td>
                                                            <td className="text-center">{data?.transactionType || '-'}</td>
                                                            <td className="text-center">{data?.title || '-'}</td>
                                                            <td className="text-center">{data?.description || '-'}</td>
                                                            <td className="text-center">₹ {data?.amount || 0}</td>
                                                            <td className="text-center">{dayjs(data.createdAt).format('DD MMM YYYY hh:mm A')}</td>
                                                            <td className="text-center d-flex justify-content-center">
                                                                <button
                                                                    onClick={() => window.open(`/users-list/${data?.user_id._id}`, '_blank')}
                                                                    className="bg-info-focus text-info-600 w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                                >
                                                                    <Icon icon="majesticons:eye-line" className="text-xl" />
                                                                </button>

                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="5" className="text-center py-4">No Revenue History Found</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
                                        <span>Page {page} of {total_pages}</span>
                                        <SmartPagination
                                            total_pages={total_pages}
                                            current_page={page}
                                            onPageChange={handlePageChange}
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RevenueHistorySection